import { initializeApp } from 'firebase/app';
import { getMessaging, type Messaging } from 'firebase/messaging';

import { getEnvVar } from '@/shared/utils/envVarConfig';
import { isMobileWeb } from '@/shared/utils/mobileWeb';
import { isNativePlatform } from '@/shared/utils/platform';

const app =
  !isNativePlatform() && !isMobileWeb()
    ? initializeApp({
        apiKey: getEnvVar('VITE_FIREBASE_API_KEY'),
        authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
        projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
        storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
        messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
        appId: getEnvVar('VITE_FIREBASE_APP_ID'),
        measurementId: getEnvVar('VITE_FIREBASE_MEASUREMENT_ID'),
      })
    : null;

// getMessaging() throws on HTTP (non-secure context) or unsupported browsers
const getMessagingSafe = (): Messaging | null => {
  if (typeof window === 'undefined' || !app) return null;
  try {
    return getMessaging(app);
  } catch {
    return null;
  }
};

export const messaging: Messaging | null = getMessagingSafe();
